export class AssignmentRuleFilters {
    assignmentRuleName: string;
    user?: string[] = [];
    dealer?: string[] = [];
    channel?: string[] = [];
    leadType?: string[] = [];
    origin?: string[] = [];
    brand?: string[];
    positiveRule: boolean;
    isActive: boolean;
    postalCode: string;
    postalCodeType: string;
    updatedAtFrom?: Date;
    updatedAtTo?: Date;
}
